import React from 'react';
import {
  Box,
  Typography,
  Paper,
  Button,
  alpha,
} from '@mui/material';
import { Apps } from '@mui/icons-material';

interface AuthorizedAppsTabProps {
  colors: any;
  glassStyle: any;
}

const AuthorizedAppsTab: React.FC<AuthorizedAppsTabProps> = ({ colors, glassStyle }) => {
  const authorizedApps = [
    { id: 1, name: 'MEE6', added: 'Dec 12, 2024', scopes: ['Identify', 'Join Servers'] },
    { id: 2, name: 'Collab.Land', added: 'Nov 05, 2024', scopes: ['Identify', 'Verify Wallet'] }
  ];

  return (
    <Box>
      <Typography variant="h5" fontWeight={800} color={colors.textPrimary} sx={{ mb: 1 }}>
        Authorized Apps
      </Typography>
      <Paper elevation={0} sx={{ bgcolor: colors.cardBg, borderRadius: '24px', p: 0, overflow: 'hidden', ...glassStyle }}>
        {authorizedApps.map((app, i) => (
          <Box key={app.id} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', p: 3, borderBottom: i < authorizedApps.length - 1 ? `1px solid ${colors.borderColor}` : 'none' }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
              <Box sx={{ width: 56, height: 56, bgcolor: alpha(colors.accent, 0.1), color: colors.accent, borderRadius: '16px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Apps fontSize="large" />
              </Box>
              <Box>
                <Typography fontWeight={700} color={colors.textPrimary} variant="h6">{app.name}</Typography>
                <Typography variant="body2" color={colors.textSecondary}>Added on {app.added}</Typography>
              </Box>
            </Box>
            <Button color="error" variant="outlined" sx={{ borderRadius: '20px', textTransform: 'none', fontWeight: 600 }}>
              Deauthorize
            </Button>
          </Box>
        ))}
      </Paper>
    </Box>
  );
};

export default AuthorizedAppsTab;